import defineActionTypes from 'utils/defineActionTypes';

// Define action types
export default defineActionTypes('rfp/company', ['LOAD_REQUEST', 'SET_FORM_DATA', 'LOAD_FAILURE']);
